import { formatPrice } from '@/features/subscription/components/CardPaymentForm';

interface PaymentMethodStepProps {
  planName: string;
  valueCents: number;
  error: string | null;
  isPending: boolean;
  onPayWithCard: () => void;
  onPayWithPix: () => void;
  onBack: () => void;
}

export function PaymentMethodStep({ planName, valueCents, error, isPending, onPayWithCard, onPayWithPix, onBack }: PaymentMethodStepProps) {
  return (
    <div className="flex flex-col items-center gap-6 py-8">
      <div className="text-center">
        <p className="font-display text-lg font-bold text-slate-900">Como quer pagar?</p>
        <p className="mt-1 text-sm text-slate-500">
          Plano {planName} — {formatPrice({ valueCents })}
        </p>
      </div>
      {error && (
        <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 text-center w-full max-w-sm">
          {error}
        </p>
      )}
      <div className="flex w-full max-w-sm flex-col gap-3">
        <button
          type="button"
          disabled={isPending}
          onClick={onPayWithCard}
          className="button w-full justify-center"
        >
          Pagar com cartão de crédito
        </button>
        <button
          type="button"
          disabled={isPending}
          onClick={onPayWithPix}
          className="button-outline w-full justify-center"
        >
          {isPending ? 'Aguarde...' : 'Pagar com PIX'}
        </button>
        <button type="button" onClick={onBack} className="text-sm text-slate-400 hover:text-slate-600 transition">
          Voltar
        </button>
      </div>
    </div>
  );
}
